




































































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import { bargainAnalysis } from "@/req/dataIndex";
@Component({
  components: { headerTitle },
})
export default class Home extends Vue {
  public loading = false;
  public timeList = ["最近7天", "最近30天"];
  public deviceList = [
    {
      id: "android",
      name: "安卓",
    },
    {
      id: "ios",
      name: "iOS",
    },
    {
      id: "pc",
      name: "pc",
    },
  ];
  public baseList: any = {
    timeId: 0,
    deviceId: 0,
    stime: "",
    etime: "",
  };
  public columns = [
    {
      width: 150,
      title: "日期",
      key: "date",
      align: "left",
    },
    {
      title: "进入交易行的账号数",
      key: "enterTradingUser",
      align: "left",
      sortable: true,
    },
    {
      title: "点击商品详情页的账号数",
      key: "goodsDetailUser",
      align: "left",
      sortable: true,
    },
    {
      title: "点击还价按钮的账号数",
      key: "clickBargainUser",
      align: "left",
      sortable: true,
    },
    {
      title: "多少账号成功发起了还价",
      key: "bargainUser",
      align: "left",
      sortable: true,
    },
    {
      title: "还价成功的订单数",
      key: "bargainSuccessUser",
      align: "left",
      sortable: true,
    },
    {
      title: "还价成功的订单总额",
      key: "bargainSuccessAmount",
      align: "left",
      sortable: true,
      sortMethod: (a, b, type) => {
        if (type === "asc") {
          return parseInt(a, 10) > parseInt(b, 10) ? 1 : -1;
        } else {
          return parseInt(a, 10) < parseInt(b, 10) ? 1 : -1;
        }
      },
    },
    {
      title: "违约金",
      key: "BreakContractMoney",
      align: "left",
      sortable: true,
      sortMethod: (a, b, type) => {
        if (type === "asc") {
          return parseInt(a, 10) > parseInt(b, 10) ? 1 : -1;
        } else {
          return parseInt(a, 10) < parseInt(b, 10) ? 1 : -1;
        }
      },
    },
  ];
  public data: any = [];
  public timeout: any = null;
  // 查询初始结束时间
  public stimeChange(data) {
    this.baseList.stime = data;
  }
  public etimeChange(data) {
    this.baseList.etime = data;
  }
  public mounted() {
    this.getList();
  }
  public async getList() {
    this.loading = true;
    const res = await bargainAnalysis({
      token: this.$fn.cookies.getToken("token"),
      begin_time: this.baseList.stime,
      end_time: this.baseList.etime,
      device: this.baseList.deviceId,
    });
    if (res.code == 0) {
      const arr: any = [];
      for (const i of Object.keys(res.data)) {
        arr.push({
          date: i,
          enterTradingUser: res.data[i].enterTradingUser,
          goodsDetailUser: res.data[i].goodsDetailUser,
          clickBargainUser: res.data[i].clickBargainUser,
          bargainUser: res.data[i].bargainUser,
          bargainSuccessUser: res.data[i].bargainSuccessUser,
          bargainSuccessAmount: res.data[i].bargainSuccessAmount,
          BreakContractMoney: res.data[i].BreakContractMoney,
        });
      }
      this.data = arr;
      this.loading = false;
    }
  }
  public addTimeType(index) {
    this.baseList.stime = "";
    this.baseList.etime = "";
    if (index != this.baseList.timeId) {
      this.baseList.timeId = index;
      this.save(1);
    }
  }
  public addDeviceType(item) {
    this.debounce(this.save, 300, item);
  }
  public debounce(func, wait, item) {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (item.id == this.baseList.deviceId) {
        this.baseList.deviceId = "";
      } else {
        this.baseList.deviceId = item.id;
      }
      func(1);
    }, wait);
  }
  public save(state) {
    if (state == 2) {
      this.baseList = {
        timeId: 0,
        deviceId: "",
        stime: "",
        etime: "",
      };
    }
    this.getList();
  }
}
